<div>

    <button (click)="goToPage()">

        @if (isRect) {
            <div class="point-note">
                @if (note.noteText) {
                    <span [innerHTML]="note.noteText | safeHtml : 'html'"></span>
                }
                @if (!note.noteText) {
                    <span>Markierung ohne Text</span>
                }
            </div>
        }

        @if (!isRect) {
            <p class="note">
                {{ 'Textmarkierung' }}
            </p>
        }
    </button>


    @if (pageText) {
        <p class="page-info"><span>{{ pageText }}</span> - {{ date | date:'dd.MM.yyyy' }},
            {{ time }}
        </p>
    }
    @if (bookFeatureActivationService.rectsActivated) {
        <i (click)="delete()"
           (keydown.enter)="delete()"
           (keydown.space)="$event.preventDefault(); delete()"
           class="fa fa-trash right"
           tabindex="0"
           role="button"
        ></i>
    }

</div>